import { jsx as I } from "../../../_virtual/jsx-runtime.mjs";
import a, { cloneElement as W } from "react";
import v from "../hooks/useChildren.mjs";
import T from "./ItemHolder.mjs";
import { isSimilarControl as z, genEmptyMeta as E } from "./common.mjs";
import H from "../hooks/useFrameState.mjs";
import { FormContext as K } from "../context/ReoFormCompContext.mjs";
import "../../../depend/rc-field-form/es/index.mjs";
import O from "../../../depend/rc-util/lib/Children/toArray.mjs";
import { isEmptyValue as $ } from "../utils/valueUtils.mjs";
import "../../../depend/rc-util/es/hooks/useLayoutEffect.mjs";
import { supportRef as k } from "../../../depend/rc-util/es/ref.mjs";
import "../../../depend/rc-util/es/warning.mjs";
import D from "../hooks/useItemRef.mjs";
import G from "../../../depend/rc-field-form/es/useWatch.mjs";
import J from "../../../depend/rc-field-form/es/Field.mjs";
import { getFieldId as Q } from "../utils/fieldUtils.mjs";
const U = "__SPLIT__", X = a.memo(
  ({ children: e }) => e,
  (e, l) => z(e.control, l.control) && e.update === l.update && e.childProps.length === l.childProps.length && e.childProps.every((u, f) => u === l.childProps[f])
);
function Y(e) {
  const {
    name: l,
    form: u,
    labelAlign: f,
    size: S,
    fixMarginBottom: _
  } = a.useContext(K), n = v(e.children), A = typeof n == "function", b = !(e.name === void 0 || e.name === null), [N, C] = a.useState(!1), w = a.useMemo(() => ({
    onFocus: () => {
      C(!0);
    },
    onBlur: () => {
      C(!1);
    }
  }), []), L = G(e.name, u), [F, R] = H({}), [s, q] = a.useState(() => E()), B = (r) => {
    q(r.destroy ? E() : r);
  }, V = (r, o) => {
    R((i) => {
      const m = {
        ...i
      }, c = [...r.name.slice(0, -1), ...o].join(U);
      return r.destroy ? delete m[c] : m[c] = r, m;
    });
  }, [d, y] = a.useMemo(() => {
    const r = [...s.errors], o = [...s.warnings];
    for (const i of Object.values(F))
      r.push(...i.errors || []), o.push(...i.warnings || []);
    return [r, o];
  }, [F, s.errors, s.warnings]), j = D();
  function P(r, o) {
    return /* @__PURE__ */ I(
      T,
      {
        ...e,
        labelAlign: e.labelAlign ?? f,
        fixMarginBottom: e.fixMarginBottom ?? _,
        errors: d,
        warnings: y,
        onSubItemMetaChange: V,
        meta: s,
        fieldId: o,
        isFocused: N,
        isFilled: !$(L),
        children: r
      }
    );
  }
  return !b && !A ? P(n) : /* @__PURE__ */ I(
    J,
    {
      ...e,
      name: e.name,
      initialValue: e.initialValue,
      rules: e.rules,
      onMetaChange: B,
      trigger: e.trigger ?? "onChange",
      dependencies: e.dependencies,
      children: (r, o) => {
        var p;
        const i = O(e.name).length && o ? o.name : [], m = Q(i, l), g = {
          ...r,
          ...w
        }, c = !!e.required || ((p = e.rules) == null ? void 0 : p.some((t) => t.required));
        let h = null;
        if (Array.isArray(n) && b)
          h = n;
        else if (a.isValidElement(n)) {
          const t = { size: S, ...n.props, ...g };
          if (t.id || (t.id = m), e.help || d.length > 0 || y.length > 0) {
            const M = [];
            (e.help || d.length > 0) && M.push(`${m}_help`), t["aria-describedby"] = M.join(" ");
          }
          d.length > 0 && (t["aria-invalid"] = "true"), c && (t["aria-required"] = "true"), k(n) && (t.ref = j(i, n));
          const x = [
            t["aria-required"],
            t["aria-invalid"],
            t["aria-describedby"]
          ];
          h = /* @__PURE__ */ I(
            X,
            {
              control: g,
              update: n,
              childProps: x,
              children: W(n, t)
            }
          );
        }
        return P(h, m);
      }
    }
  );
}
const Ie = Y;
export {
  Ie as default
};
//# sourceMappingURL=index.mjs.map
